import io from 'socket.io-client';

class WebSocketClient {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.eventHandlers = new Map();
  }

  connect() {
    if (this.socket && this.isConnected) {
      return;
    }

    // Determine the WebSocket URL based on environment
    const wsUrl = process.env.NODE_ENV === 'production' 
      ? window.location.origin  // Use same origin in production
      : 'http://localhost:5001';  // Use localhost in development
    
    this.socket = io(wsUrl, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
      forceNew: false,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      maxReconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      console.log('WebSocket connected');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('WebSocket disconnected');
      this.isConnected = false;
    });

    this.socket.on('connected', (data) => {
      console.log('WebSocket authentication successful:', data);
    });

    // Set up event listeners
    this.socket.on('move_status_changed', (data) => {
      console.log('Move status changed:', data);
      this.notifyHandlers('move_status_changed', data);
    });

    this.socket.on('trailer_location_updated', (data) => {
      console.log('Trailer location updated:', data);
      this.notifyHandlers('trailer_location_updated', data);
    });

    this.socket.on('location_history_updated', (data) => {
      console.log('Location history updated:', data);
      this.notifyHandlers('location_history_updated', data);
    });

    this.socket.on('connect_error', (error) => {
      console.error('WebSocket connection error:', error);
    });

    this.socket.on('reconnect', (attemptNumber) => {
      console.log('WebSocket reconnected after', attemptNumber, 'attempts');
    });

    this.socket.on('reconnect_error', (error) => {
      console.error('WebSocket reconnection error:', error);
    });

    this.socket.on('reconnect_failed', () => {
      console.error('WebSocket reconnection failed');
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  addEventHandler(event, handler) {
    if (!this.eventHandlers.has(event)) {
      this.eventHandlers.set(event, new Set());
    }
    this.eventHandlers.get(event).add(handler);
  }

  removeEventHandler(event, handler) {
    if (this.eventHandlers.has(event)) {
      this.eventHandlers.get(event).delete(handler);
    }
  }

  notifyHandlers(event, data) {
    if (this.eventHandlers.has(event)) {
      this.eventHandlers.get(event).forEach(handler => {
        try {
          handler(data);
        } catch (error) {
          console.error('Error in WebSocket event handler:', error);
        }
      });
    }
  }

  getConnectionStatus() {
    return this.isConnected;
  }
}

// Create a singleton instance
const websocketClient = new WebSocketClient();

export default websocketClient;